<template>
  <div>
    <div class="order" v-if="isImagefinish">
      <h2>訂單</h2>
      <div v-if="allOrders.length == 0">
        目前無任何訂單，歡迎購買建立您的第一筆訂單！
      </div>
      <div v-else class="order-wrap" v-for="(item,index) in allOrders" :key="item.id" :class="{renew:isCanRenew(item.createTime,index)}">
        <div class="order-status-wrap">
          <div class="order-status" v-if="item.shippedTime">已完成</div>
          <div class="order-status" v-else-if="item.paidTime">未出貨</div>
          <div class="order-status" v-else>未付款</div>
          <div>
            <button v-if="isCanRenew(item.createTime,index)" @click="renewOrder(item.id)">重新生效</button>
            <button v-else v-on:click="goOrderDetail(item.id)">查看詳情</button>
          </div>
        </div>
        <div class="order-info">
          <p>訂單編號：{{item.orderId}}</p>
          <p>成立日期：{{item.createTime}}</p>
        </div>
        <div class="ordertitle">
          <div class="pc-display-only"></div>
          <div class="item-name-title pc-display-only">
            <p>商品名稱</p>
          </div>
          <div class="item-amount-title pc-display-only">
            <p>數量</p>
          </div>
          <div class="item-price-title pc-display-only">
            <p>金額</p>
          </div>
        </div>
        <!-- 使用v-for 需要在包一個div -->
        <div class="orderitems" v-for="(product,productIndex) in item.product" :key="productIndex">
          <div class="item-img" @click="lightboxControl(index,productIndex)">
            <img v-bind:src="product.imageUrl" alt="item">
            <span>點擊看大圖</span>
            <div class="zoomin"></div>
          </div>
          <div class="item-name">
            <span>{{product.shape}}-{{product.style}}</span>
            <span>{{product.size.length}}{{product.size.unit}}{{product.size.weight}}錢{{product.size.way}}</span>
            <div>配件選擇: {{product.accessory_name === null?'無':product.accessory_name}} - TWD {{product.accessory_price=== null?'0':product.accessory_price}}</div>
          </div>
          <div class="item-amount">
            <span class="mobile-display-only">數量：</span>
            <span>{{product.amount}}</span>
          </div>
          <div class="item-price">
            <span class="mobile-display-only">金額：</span>
            <span>TWD {{singleProductSum(product.total,product.accessory_price,
                    product.amount)}}</span>
          </div>
        </div>
        <div class="order-total">
          <span>總金額</span>
          <span>TWD {{item.sum}}</span>
        </div>
      </div>
      <div class="mobile_backNav" v-if="!isWeb">
        <i class="fa fa-angle-left"></i>
        <router-link to="/gold/member_mobile">返回會員帳號</router-link>
      </div>
      <div class="lightbox" v-bind:class="{'displaynone':closeLightbox}" v-body-scroll-lock="!closeLightbox">
        <div class="center-container">
          <img v-bind:src="lightboxImg">
          <div href="#" class="lightbox-close" @click="closeLightbox=!closeLightbox">
            <img src="@/images/icon-close@2x-white.png">
          </div>
        </div>
      </div>
    </div>
    <div class="load" v-else>
      <div class="line"></div>
      <div class="line"></div>
      <div class="line"></div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "memberOrder",
  data() {
    return {
      allOrders: "",
      isWeb: true,
      isImagefinish: false,
      lightboxImg: "",
      closeLightbox: true
    };
  },
  created() {
    let token = this.$store.getters.getToken;
    axios({
      url: this.$store.getters.getGlobalUrl + "orders",
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token
      }
    })
      .then(response => {
        this.allOrders = response.data;
        this.allOrders.forEach(item => {
          item.product.forEach(item => {
            item.size.way = this.$store.getters.getTransformWay(item.size.way);
            item.size.unit = this.$store.getters.getTransformUnit(
              item.size.unit
            );
          });
        });
        this.baseToImg();
      })
      .catch(e => {
        this.$router.push("/gold/homepage");
      });
    this.getDeviceSize();
  },
  watch: {
    allOrders: {
      handler() {
        if (typeof this.allOrders !== "undefined") {
          //check img loading
          let checkNum = 0;
          this.allOrders.forEach(item => {
            item.product.forEach(item => {
              if (item.imageUrl.substring(0, 4) == "data") {
                checkNum = checkNum + 1;
              }
            });
          });
          if (checkNum == this.allOrders.length) {
            this.isImagefinish = true;
          }
        }
      },
      deep: true
    }
  },
  methods: {
    baseToImg() {
      this.allOrders.forEach(item => {
        item.product.forEach(item => {
          axios({
            url: `${item.imageUrl}`,
            method: "get"
          })
            .then(response => {
              item.imageUrl = response.data;
            })
            .catch(e => {
              alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
            });
        });
      });
    },
    getDeviceSize() {
      let size = this.$store.getters.getDeviceSize;
      if (size > 585) {
        this.isWeb = true;
      } else {
        this.isWeb = false;
      }
    },
    goOrderDetail(id) {
      this.$store.dispatch("setSingleId", id);
      let size = this.$store.getters.getDeviceSize;
      if (size > 585) {
        this.$router.push("/gold/member/member_orderdetail");
      } else {
        this.$router.push("/gold/member_mobile/member_orderdetail");
      }
    },
    lightboxControl(index, productIndex) {
      this.closeLightbox = !this.closeLightbox;
      this.lightboxImg = this.allOrders[index].product[productIndex].imageUrl;
    },
    async renewOrder(id) {
      try {
        let newId = await this.$store.dispatch("renewOrder", id);
        this.$router.push({
          name: "cart_renew",
          params: { oldId: id, newId: newId }
        });
      } catch (e) {
        alert(`錯誤訊息：${e}，請重新檢查`);
      }
    }
  },
  computed: {
    singleProductSum() {
      return function(productPrice, accessoryPrice, amount) {
        if (accessoryPrice === null) {
          return productPrice;
        } else {
          return parseInt(productPrice) + accessoryPrice * amount;
        }
      };
    },
    isCanRenew() {
      return function(createTime, index) {
        if (this.allOrders[`${index}`].isPaid === "1") {
          return false;
        }
        let now = this.moment(new Date());
        let create = this.moment(createTime);
        if (now.diff(create, "hour") > 24) {
          return true;
        } else {
          return false;
        }
      };
    }
  }
};
</script>

<style scoped lang="scss">
.order {
  text-align: left;
  @include phone {
    min-width: 273px;
  }

  h2 {
    font-size: 35px;
    letter-spacing: 2px;
    color: $primaryDeepColor;
    margin: 0;
    padding-bottom: 12px;
  }
  p {
    margin: 0;
  }
}

.order-info {
  font-size: 15px;
  color: $secondaryDeepColor1;
  margin-bottom: 9px;
  display: flex;
  flex-direction: row;
  @include table {
    flex-direction: column;
    text-align: left;
  }

  p:nth-child(1) {
    border-right: 1px solid #979797;
    padding-right: 30px;
    @include table {
      border: none;
      margin: 0;
    }
  }
  p:nth-child(2) {
    padding-left: 30px;
    @include table {
      padding: 0;
      margin: 0;
    }
  }
}

.ordertitle {
  display: grid;
  grid-template-columns: 3fr 3fr 1fr 1fr;
  grid-template-rows: 1fr;
  align-items: center;
  width: 100%;
  color: $secondaryDeepColor1;
  border-top: 1px solid $primaryDeepColor;
  border-bottom: 1px solid $primaryDeepColor;
  @include betweenTableTablePro {
    grid-template-columns: 2fr 3fr 0.5fr 1fr;
  }
  @include table {
    grid-template-columns: 1fr;
    align-items: flex-start;
  }
  p {
    line-height: 31px;
    margin: 0;
  }
  .item-name-title {
    p {
      text-align: left;
    }
  }

  .item-amount-title {
    font-size: 17px;
    text-align: center;
    @include table {
      text-align: left;
    }
    span:nth-child(1) {
      display: none;
      @include table {
        display: initial;
      }
    }
  }
  .item-price-title {
    font-size: 17px;
    text-align: center;
    @include table {
      text-align: left;
      padding-bottom: 16px;
    }
    span:nth-child(1) {
      display: none;
      @include table {
        display: initial;
      }
    }
  }
}

.orderitems {
  display: grid;
  grid-template-columns: 3fr 3fr 1fr 1fr;
  grid-template-rows: auto;
  align-items: center;
  color: $secondaryDeepColor1;
  margin-top: 16px;
  @include betweenTableTablePro {
    grid-template-columns: 2fr 3fr 0.5fr 1fr;
  }
  @include table {
    grid-template-columns: 1fr;
    align-items: flex-start;
  }
  .item-img {
    text-align: center;
    :hover {
      cursor: pointer;
    }
    @include table {
      text-align: left;
    }
    img {
      width: 40px;
      height: auto;
      vertical-align: middle;
      padding: 22px 12px;
      @include betweenTableTablePro {
        display: block;
        margin: 0 auto;
        padding: 22px 0px 0px 0px;
      }
      @include table {
        display: inline-block;
        padding-bottom: 12px;
        padding-right: 12px;
      }
    }
  }
  .item-name {
    margin-bottom: 8px;
    text-align: left;
    span:nth-child(1) {
      display: block;
    }
  }
  .item-amount {
    text-align: center;
    @include table {
      text-align: left;
    }
  }
  .item-price {
    text-align: center;
    @include table {
      text-align: left;
    }
  }
  .mobile-display-only {
    display: none;
    @include table {
      display: inline-block;
    }
  }
}

.pc-display-only {
  @include table {
    display: none;
  }
}

.order-total {
  text-align: right;
  span:nth-child(1) {
    font-size: 15px;
    padding-right: 10px;
  }
  span:nth-child(2) {
    font-size: 24px;
    color: $secondaryDeepColor1;
  }
}

.order-wrap {
  border: 1px solid $primaryDeepColor;
  padding: 16px;
  position: relative;
  margin-bottom: 16px;
  &.renew {
    .order-status {
      opacity: 0.5;
    }
    .order-info {
      opacity: 0.5;
    }
    .ordertitle {
      opacity: 0.5;
    }
    .orderitems {
      opacity: 0.5;
    }
    .order-total {
      opacity: 0.5;
    }
  }
  .order-status-wrap {
    padding-bottom: 16px;
    display: flex;
    .order-status {
      font-size: 24px;
      color: #7ed321;
      padding-right: 16px;
      display: inline-block;
    }
    .order-status.renew-text {
      color: $secondaryDeepColor1;
    }
    button {
      border: 1px solid $primaryDeepColor;
      color: $secondaryDeepColor1;
      width: 97px;
      height: 30px;
      padding: 0px;
      font-size: 15px;
      background-color: transparent;
    }
  }
}

a {
  display: block;
  color: $primaryDeepColor;
}

.mobile_backNav {
  margin-top: 24px;
  font-weight: 600;
  display: flex;
  align-items: center;
  i {
    color: $primaryDeepColor;
    margin-right: 10px;
  }
  a {
    text-align: center;
  }
}
.zoomin {
  width: 12px;
  height: 12px;
  display: inline-block;
  background-image: url("../../images/biger@2x.png");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  margin-left: 3px;
  &:hover {
    cursor: pointer;
  }
}
.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1111111;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  .center-container {
    flex: 0 0 80vmin;
    background-color: $secondaryColor3;
    @include phone {
      flex: 0 0 90vmin;
    }
  }
  img {
    width: 100%;
    height: auto;
    max-height: 80vh;
    object-fit: contain;
  }
  .lightbox-close {
    box-sizing: border-box;
    max-width: 45px;
    max-height: 45px;
    padding: 8px;
    background: $primaryDeepColor;
    color: #fff;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.displaynone {
  display: none;
}
//loading
.load {
  padding-top: 120px;
}
.load .line:nth-last-child(1) {
  animation: loadingC 0.6s 0.1s linear infinite;
}
.load .line:nth-last-child(2) {
  animation: loadingC 0.6s 0.2s linear infinite;
}
.load .line:nth-last-child(3) {
  animation: loadingC 0.6s 0.3s linear infinite;
}
.line {
  display: inline-block;
  width: 15px;
  height: 15px;
  margin: 3px;
  border-radius: 15px;
  background-color: #a8894c;
}
@keyframes loadingC {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, 15px);
  }
  100% {
    transform: translate(0, 0);
  }
}
</style>
